var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53999 1.2793H3.45999C1.95778 1.2793 0.73999 2.49708 0.73999 3.9993V8.0793C0.73999 9.58148 1.95778 10.7993 3.45999 10.7993H7.53999C9.04218 10.7993 10.26 9.58148 10.26 8.0793V3.9993C10.26 2.49708 9.04218 1.2793 7.53999 1.2793Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49996 8.08C4.37327 8.08 3.45996 7.16669 3.45996 6.04C3.45996 4.91331 4.37327 4 5.49996 4C6.62665 4 7.53996 4.91331 7.53996 6.04C7.53996 6.58101 7.32501 7.09992 6.94244 7.48248C6.55988 7.86505 6.04097 8.08 5.49996 8.08Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22004 2.64C7.84449 2.64 7.54004 2.94445 7.54004 3.32C7.54004 3.69555 7.84449 4 8.22004 4C8.59559 4 8.90004 3.69555 8.90004 3.32C8.90004 2.94445 8.59559 2.64 8.22004 2.64Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22 2.98016C8.03223 2.98016 7.88 3.13238 7.88 3.32016C7.88 3.50793 8.03223 3.66016 8.22 3.66016C8.40778 3.66016 8.56 3.50793 8.56 3.32016C8.56 3.13238 8.40778 2.98016 8.22 2.98016Z",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramicon);
export default __webpack_public_path__ + "static/media/instagramicon.437f68873e525f27954c2628b98df767.svg";
export { ForwardRef as ReactComponent };